/**
 * GoogleSignInButton — "Continue with Google" CTA used on /login and /signup.
 *
 * On click, redirects the browser to Emergent's OAuth gateway with the
 * current origin + '/app' as the post-auth return URL. After Google
 * auth, the user lands back at <origin>/app#session_id=XYZ where
 * AuthCallback completes the exchange.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT
 * URLS, THIS BREAKS THE AUTH.
 */
import { useState } from 'react';

const EMERGENT_AUTH_URL = 'https://auth.emergentagent.com/';

export default function GoogleSignInButton({ label = 'Continue with Google', testId = 'google-signin-btn' }) {
    const [loading, setLoading] = useState(false);

    const onClick = () => {
        setLoading(true);
        // Compose redirect URL dynamically from the current origin so the
        // same code works in preview, production, and local dev without
        // any env config.
        const redirectUrl = window.location.origin + '/app';
        window.location.href = `${EMERGENT_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={loading}
            data-testid={testId}
            className="w-full flex items-center justify-center gap-3 bg-white hover:bg-slate-100 text-slate-900 font-medium rounded-sm border border-marigold/10 px-4 py-2.5 text-sm transition-colors disabled:opacity-60 disabled:cursor-wait"
        >
            <GoogleLogo />
            <span>{loading ? 'Redirecting…' : label}</span>
        </button>
    );
}


function GoogleLogo() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
        </svg>
    );
}
